import React, { useEffect, useState } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { AsyncPaginate } from "react-select-async-paginate";
import moment from "moment";
import { ForeignData_API } from "../../../APIs/ForeignData.api";
import RenderInputs from "../../../Components/Inputs";
import submitForm from "../../../services/submitForm";
import RenderInputsPNK from "./InputsPNK";

export default function CreatePhieuNhapkho() {
  const {
    lang,
    pages,
    proxy,
    functions,
    database: { fields, tables },
  } = useSelector((state) => state);
  const { makeAutoIncreament } = functions;
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    getValues,
    reset,
    control,
    formState: { errors },
  } = useForm();
  const [refresh, setRefresh] = useState(false);
  const [defaultValues, setDefaultValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [isTables, setTables] = useState([]);
  const [options, setOptions] = useState({});
  const [isDisabled, setDisabled] = useState();
  const [inputFields, setInputFields] = useState([
    {
      name: "Mã phiếu Nhập Kho",
      alias: "2SPN",
      type: "text",
      required: true,
      readOnly: true,
    },
    {
      name: "Lệnh đóng bao",
      alias: "2MLĐB",
      type: "select",
      required: true,
      table_id: 22587,
      displayFields: ["1MLĐB", "23MSP", "2SCSX"],
      isPK: "1MLĐB",
      isApi: "/api/LDB/optionLDB",
      // isMulti: true,
      dataFromLDB: [
        {
          key: "2SCSX",
          alias: "1SLN",
          value: "2SCSX",
        },
        {
          key: "SanPham",
          alias: "24MSP",
          label: ["22MSP", "10TSP"],
          value: "22MSP",
        },
        // {
        //   key: "ToChuc",
        //   alias: "maToChuc",
        //   label: ["2MLK", "7LK"],
        //   value: "2MLK",
        // },
        {
          key: "Kho",
          alias: "13MK",
          label: ["maKhoERPKho", "4TK", "8LK"],
          value: "11MK",
        },
        {
          key: "KhuVuc",
          alias: "maKhuVuc",
          label: ["7MKV", "2TKV"],
          value: "7MKV",
        },
      ],
    },
    {
      name: "Mã phiếu nhập kho ERP",
      alias: "maPhieuNhapKhoERP",
      type: "text",
    },
    {
      name: "Số Lượng Dự Kiến (Tấn)",
      alias: "1SLN",
      type: "float",
    },
    {
      name: "Ngày Nhập",
      alias: "5NN",
      type: "datetime-local",
    },
    {
      name: "Mã Thành Phẩm",
      alias: "24MSP",
      type: "select",
      table_id: 21692,
      displayFields: ["22MSP", "10TSP"],
      required: true,
      isPK: "22MSP",
    },
    {
      name: "Tên Kho Con",
      alias: "13MK",
      type: "select",
      table_id: 21719,
      displayFields: ["maKhoERPKho", "4TK", "8LK"],
      required: true,
      isPK: "11MK",
    },
    {
      name: "Vị Trí Trong Kho",
      alias: "viTriTrongKhoNK",
      isApi: "/api/PNK/viTriTrongKhoNK",
      type: "select",
      table_id: 21872,
      displayFields: ["11MVT", "4TVT"],
      // required: true,
      isPK: "11MVT",
      isParent: {
        alias: "13MK",
      },
    },
    {
      name: "Loại Nhập Kho",
      alias: "2MLNK",
      type: "select",
      table_id: 22584,
      displayFields: ["1TLNK"],
      required: true,
      isPK: "1MLNK",
    },
    {
      name: "Khu Vực",
      alias: "maKhuVuc",
      type: "select",
      table_id: 21676,
      displayFields: ["7MKV", "2TKV"],
      required: true,
      isPK: "7MKV",
    },
    {
      name: "Vị Trí Kho",
      alias: "viTriKho",
      type: "select",
      table_id: 21872,
      displayFields: ["11MVT", "4TVT"],
      required: true,
      isPK: "11MVT",
    },
    {
      name: "Ghi Chú",
      alias: "19GC",
      type: "textarea",
    },
    {
      name: "Chứng Từ KCS",
      alias: "chungTuKCSPNK",
      type: "file",
    },
  ]);
  const _token = localStorage.getItem("_token");
  const [lichDongBao, maKho] = watch(["2MLĐB", "11MK"]);

  const searchParams = new URLSearchParams({
    lichDongBao,
    maKho,
  });

  useEffect(() => {
    fetch(proxy() + `/api/PNK/search`, {
      method: "POST",
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { success, data, kho } = res;
        if (success) {
          if (lichDongBao || maKho) {
            const field = inputFields.find(
              ({ dataFromLDB = [] }) => dataFromLDB?.length
            );
            if (field) {
              field?.dataFromLDB?.forEach((item) => {
                const { key, value, alias, label = [], items = [] } = item;

                if (label.length) {
                  const mappedLabel = label
                    .map((lb) => data?.[key]?.[lb])
                    .filter(Boolean)
                    .join(field?.betChar || "|");
                  setValue(alias, data?.[key]?.[value]);
                  setSelectedValues((prev) => {
                    const newPrev = { ...prev };
                    newPrev[alias] = {
                      label: mappedLabel ?? "",
                      value: data[key]?.[value],
                    };
                    return newPrev;
                  });
                } else {
                  setValue(alias, data[key]);
                }
              });
            }
          } else {
            setValue("2SPN", data);
            setValue("5NN", moment().format("YYYY-MM-DDTHH:mm"));
            setValue("13MK", kho?.maKhoERPKho);
            setSelectedValues((prev) => ({
              ...prev,
              "13MK": {
                label: [kho?.maKhoERPKho, kho?.["4TK"], kho?.["8LK"]]
                  .filter(Boolean)
                  .join("|"),
                value: kho?.maKhoERPKho,
              },
            }));
          }
        }
      });
  }, [refresh]);
  // useEffect(() => {
  //   fetch(proxy() + "/api/PNK", {
  //     headers: {
  //       Authorization: _token,
  //       "content-type": "application/json",
  //     },
  //   })
  //     .then((res) => res.json())
  //     .then((res) => {
  //       const { success, data } = res;
  //       if (success) {
  //         setValue("2SPN", data);
  //       }
  //     });
  // }, []);

  useEffect(() => {
    const tableId = 22751;
    const api_id = [];

    pages
      .filter(({ is_hidden }) => !is_hidden)
      .forEach((page) => {
        page.children
          .filter(({ is_hidden }) => !is_hidden)
          .forEach((child) => {
            child.component.forEach((item) => {
              const { props } = item;
              const findId = props.source?.tables?.find(
                (item) => item.id === tableId
              );
              if (findId) {
                const currentPage = pages.find((p) => p.block === item.id)
                  ?.component?.[0]?.children;

                if (currentPage) {
                  const mappedFields = currentPage
                    .map((item) => {
                      const {
                        props: {
                          variable_name,
                          title: { content, visible },
                          required,
                          displayField,
                          textarea,
                          betChar,
                        },
                      } = item;
                      if (!visible) return null;

                      const field = inputFields.find(
                        ({ alias }) => alias === variable_name
                      );

                      if (field) {
                        return {
                          ...field,
                          name: content,
                          alias: variable_name,
                          type: textarea ? "textarea" : field.type,
                          required,
                          betChar,
                          displayFields:
                            displayField && displayField.length
                              ? displayField?.map(({ value }) => value)
                              : field.displayFields,
                        };
                      }
                    })
                    .filter(Boolean);
                  setInputFields(mappedFields);
                }
                setTables(findId);
                api_id.push(props?.buttons?.add?.api?.api_id);
              }
            });
          });
      });

    fetch(`${proxy()}/apis/api/${api_id?.[0]}/input_info`, {
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { data } = res;
        if (data) {
          setDefaultValues(data.display_fields);
          data.display_fields.forEach((item) => {
            if (inputFields.some(({ alias }) => item.fomular_alias === alias)) {
              const { default_value, fomular_alias } = item;
              if (default_value) {
                // setValue(fomular_alias, item.default_value);
              }
            }
          });
        }
      });
  }, [pages]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        for (const item of inputFields) {
          if (item.type === "input-select") {
            const table_id = item?.table_id;
            const foreignResponse = await ForeignData_API.get(proxy(), _token, {
              table_id,
            });
            const { data: foreignData = [] } = foreignResponse;

            if (foreignData.length) {
              const mapped = foreignData.reduce((acc, curr) => {
                const fields = item?.displayFields?.map((field) => curr[field]);

                if (fields.some((field) => field)) {
                  acc.push({
                    label: fields.join("|"),
                    value: fields?.[0],
                  });
                }
                return acc;
              }, []);
              setOptions(mapped);
            }
          }

          // setOptions((prev) => ({ ...prev, ...selectedValuesTemp }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [inputFields, _token]);

  const onSubmit = async (data) => {
    const trimmedData = Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ])
    );
    const mappedData = {
      data: trimmedData,
      default_field_value: defaultValues,
      table: isTables,
    };

    const res = await submitForm({
      url: `/api/PNK`,
      data: mappedData,
      proxy,
      lang,
      inputFields,
    });
    if (res) {
      inputFields.forEach((item) => {
        const { alias, readOnly } = item;
        if (!readOnly) {
          reset({
            [alias]: "",
          });
        }
      });
      setRefresh(true);
      setSelectedValues({});
    }
  };

  return (
    <>
      <form className="midd_cont" onSubmit={handleSubmit(onSubmit)}>
        <div className="container-fluid">
          <div className="row column_title">
            <div className="col-md-12">
              <div className="page_title">
                <h4 className="ml-1">Quản Lý Dữ Liệu</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="white_shd full margin_bottom_30 mb-0">
                <div className="full graph_head_cus d-flex">
                  <div className="heading1_cus margin_0 ">
                    <h5>
                      <label className="pointer" onClick={() => navigate(-1)}>
                        <a title={lang["back"]}>
                          <i className=" fa fa-chevron-circle-left mr-1 mt-3 mb-0 nav-item nav-link" />
                        </a>
                        Phiếu Nhập Kho
                        <i className="fa fa-chevron-right ml-2 mr-1" />
                        {lang["create"]}
                      </label>
                    </h5>
                  </div>
                </div>
                <div className="table_section padding_infor_info input_put">
                  <div className="col-md-12">
                    <div
                      style={{
                        height: "70vh",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <div className="row w-50-pct mg-auto p-1 bg-white input-put">
                        {inputFields.map((field, index) => {
                          const {
                            required,
                            name,
                            alias,
                            type,
                            col,
                            readOnly = false,
                            table_id,
                            displayFields,
                            style,
                          } = field;
                          return (
                            <>
                              <div
                                className={` ${
                                  col ? col : `col-sm-8  offset-sm-2`
                                } mb-3`}
                                {...register(alias)}
                                style={style}
                              >
                                <label class="form-label">
                                  {name}
                                  {required && (
                                    <span style={{ color: "red" }}>*</span>
                                  )}
                                </label>
                                <RenderInputsPNK
                                  control={control}
                                  register={register}
                                  selectedValues={selectedValues}
                                  setSelectedValues={setSelectedValues}
                                  field={field}
                                  options={options}
                                  setValue={setValue}
                                  getValues={getValues}
                                  refresh={refresh}
                                  watch={watch}
                                  isDisabled={isDisabled}
                                  setDisabled={setDisabled}
                                />
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </div>
                    <div className="col-sm-7 offset-sm-3 p-0">
                      <div className="d-flex justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-success mr-2"
                          style={{
                            minWidth: "105px",
                          }}
                          // onClick={() => setSubmit(true)}
                        >
                          Thêm mới
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger"
                          style={{
                            minWidth: "105px",
                          }}
                          onClick={() => navigate(-1)}
                        >
                          Đóng
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
